import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";

const GetLeadDealController = async (leadId) => {
  /** New Code */
  /**
   * input: null
   * output: lead deal document / collection
   * description: get lead deal / get documents
   */

  try {
    const dealsCollection = collection(db, "deals");
    const q = query(dealsCollection, where("client.id", "==", leadId));
    const dealSnapshot = await getDocs(q);
    const dealsData = [];
    dealSnapshot.forEach((deal) =>
      dealsData.push({ id: deal.id, ...deal.data() })
    );

    return dealsData;
  } catch (error) {
    console.log(error);
  }
};

export default GetLeadDealController;
